/* Floating checkout bar on the cart page (mobile): hides itself while the
   in-page checkout button (#checkout) is visible in the viewport.

   Defined as a custom element on purpose: cart.js re-renders the whole
   `.js-cart-summary` wrapper (including this element and #checkout) on every
   cart change, and connectedCallback re-attaches the observer to the fresh
   button after each swap. */

if (!customElements.get('cart-floating-checkout')) {
  customElements.define(
    'cart-floating-checkout',
    class CartFloatingCheckout extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById('checkout');
        if (!target || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-docked', entry.isIntersecting);
          },
          { threshold: 0.1 }
        );
        this.observer.observe(target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
